import { render, staticRenderFns } from "./Ecarewave.vue?vue&type=template&id=3c46e6ec&scoped=true&"
import script from "./Ecarewave.vue?vue&type=script&lang=js&"
export * from "./Ecarewave.vue?vue&type=script&lang=js&"
import style0 from "./Ecarewave.vue?vue&type=style&index=0&id=3c46e6ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46e6ec",
  null
  
)

export default component.exports